/*************************
  🚨 Auto-generated file. Do not modify directly!
  🚨 Instead, modify ./svg-template.ts or the SVG file
  🚨 See packages/bundler for more info
*************************/
import * as React from 'react';
import type { SVGIconProps } from '../types';
export function ReusableContent({
  className,
  size,
  style
}: SVGIconProps) {
  const props = {
    preserveAspectRatio: 'xMidYMid meet',
    className,
    style: {
      verticalAlign: 'middle',
      ...style
    },
    width: size ?? '1em',
    height: size ?? '1em'
  };
  return <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 16 16" {...props}><g stroke="currentColor" strokeLinecap="round" strokeLinejoin="round" strokeWidth={1.2} clipPath="url(#ReusableContent_svg__a)"><path d="m11.792 12.046-1.354 1.477L11.792 15" /><path d="M14.5 10.882v.975c0 .92-.746 1.666-1.667 1.666h-1.718M4.208 3.954l1.354-1.477L4.208 1" /><path d="M1.5 5.118v-.974c0-.921.746-1.667 1.667-1.667h1.718" /><rect width={11.047} height={13} strokeDasharray="7 14" rx={2} transform="matrix(0 1 1 0 1.5 2.477)" /><path d="M6.031 5.117h5.26a.5.5 0 0 1 .5.5v3.824M4.209 6.594v3.789a.5.5 0 0 0 .5.5h5.188" /></g><defs><clipPath id="ReusableContent_svg__a"><path fill="#fff" d="M0 0h16v16H0z" /></clipPath></defs></svg>;
}
;